import { animated, useTransition } from 'react-spring';
import React__default, { useState } from 'react';
import { Toast } from './Toast.es.js';
import styled from '@emotion/styled';
import { uid } from '../../../helpers/utils.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ToastContextDesktop = React__default.createContext({});
const toastPlacement = [
  "topLeft",
  "topRight",
  "bottomLeft",
  "bottomRight"
];
const ToastProviderDesktop = ({
  children
}) => {
  const [toastPlacementState, setToastPlacementState] = useState({
    topLeft: [],
    topRight: [],
    bottomLeft: [],
    bottomRight: []
  });
  const transitionConfig = { tension: 125, friction: 20, precision: 0.1 };
  const toastTransitions = {
    topRight: useTransition(toastPlacementState.topRight, {
      from: { opacity: 0, transform: "translate(40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, -10px)" },
      config: transitionConfig
    }),
    bottomRight: useTransition(toastPlacementState.bottomRight, {
      from: { opacity: 0, transform: "translate(40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, 10px)" },
      config: transitionConfig
    }),
    topLeft: useTransition(toastPlacementState.topLeft, {
      from: { opacity: 0, transform: "translate(-40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, -10px)" },
      config: transitionConfig
    }),
    bottomLeft: useTransition(toastPlacementState.bottomLeft, {
      from: { opacity: 0, transform: "translate(-40px, 0px)" },
      enter: { opacity: 1, transform: "translate(0px, 0px)" },
      leave: { opacity: 0, transform: "translate(0px, 10px)" },
      config: transitionConfig
    })
  };
  const open = (props) => {
    const toastPlacement2 = props.placement || "topRight";
    if (toastPlacement2 === "topLeft" || toastPlacement2 === "topRight") {
      setToastPlacementState((state) => __spreadProps(__spreadValues({}, state), {
        [toastPlacement2]: [...state[toastPlacement2], __spreadProps(__spreadValues({}, props), { id: uid() })]
      }));
      return;
    }
    setToastPlacementState((state) => __spreadProps(__spreadValues({}, state), {
      [toastPlacement2]: [__spreadProps(__spreadValues({}, props), { id: uid() }), ...state[toastPlacement2]]
    }));
  };
  const onClose = (placement, item) => {
    setToastPlacementState((state) => __spreadProps(__spreadValues({}, state), {
      [placement]: state[placement].filter((e) => e.id !== item.id)
    }));
  };
  const toast = {
    open
  };
  ["success", "info", "error", "warning"].forEach((type) => {
    toast[type] = (props) => open(__spreadValues({ type }, props));
  });
  return /* @__PURE__ */ React__default.createElement(ToastContextDesktop.Provider, {
    value: toast
  }, children, toastPlacement.map((place) => {
    var _a;
    if (!((_a = toastPlacementState[place]) == null ? void 0 : _a.length))
      return;
    const placementCls = `teko-toast teko-toast-${place}`;
    return /* @__PURE__ */ React__default.createElement(ToastPositionGroup, {
      key: place,
      className: placementCls
    }, toastTransitions[place]((style, item) => {
      return /* @__PURE__ */ React__default.createElement(AnimatedDiv, {
        key: item.id,
        style
      }, /* @__PURE__ */ React__default.createElement(Toast, __spreadProps(__spreadValues({}, item), {
        onClose: () => onClose(place, item)
      })));
    }));
  }));
};
const ToastPositionGroup = styled.div`
  &.teko-toast {
    position: fixed;
    z-index: 1070;
    &.teko-toast-topRight {
      right: 24px;
      top: 24px;
    }
    &.teko-toast-topLeft {
      left: 24px;
      top: 24px;
    }
    &.teko-toast-bottomLeft {
      left: 24px;
      bottom: 24px;
    }
    &.teko-toast-bottomRight {
      right: 24px;
      bottom: 24px;
    }
  }
`;
const AnimatedDiv = styled(animated.div)`
  margin-bottom: 16px;
`;

export { ToastContextDesktop, ToastProviderDesktop, toastPlacement };
